import { createSlice } from "@reduxjs/toolkit";
import {
  ActivityTypeDTO,
  ProjectActivityDTO,
} from "../../models/Activity.model";
import { GetActivityTypes, GetProjectActivity } from "../thunks/activityThunks";

export interface ActivityState {
  activityTypes: ActivityTypeDTO[];
  projectActivities: ProjectActivityDTO[];
  loading: boolean;
  error: string | null;
  initialized: boolean;
}

const initialState: ActivityState = {
  activityTypes: [],
  projectActivities: [],
  loading: false,
  error: null,
  initialized: false,
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearActivities: (state) => {
      state.activityTypes = [];
      state.projectActivities = [];
      state.initialized = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetActivityTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetActivityTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.activityTypes = action.payload.activityTypes;
        state.initialized = true;
      })
      .addCase(GetActivityTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch activity types";
      })

      .addCase(GetProjectActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetProjectActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.projectActivities = action.payload.activities;
        state.initialized = true;
      })
      .addCase(GetProjectActivity.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch project activities";
      });
  },
});

export const { clearError, clearActivities } = activitySlice.actions;
export default activitySlice.reducer;
